import {
  ChatBubbleLeftIcon,
  EnvelopeIcon,
  PhoneArrowUpRightIcon,
} from '@heroicons/react/24/outline';
import React from 'react';

import {
  EventRow,
  EventText,
  EventUser,
} from '@/components/domain-events-v2/shared';

/* eslint-disable @typescript-eslint/no-explicit-any */
// These events are new and may not be in the generated types yet
// Using any type until the API types are regenerated
export const clientCommunicationEvents: Record<string, any> = {
  client_communication_email_sent: {
    icon: EnvelopeIcon,
    iconColor: 'text-blue-500',
    priority: 'medium',
    render: (event: any, inline: boolean) => {
      const { payload } = event;
      const recipient = payload.recipient_email || payload.recipient_name;

      if (inline) {
        return (
          <EventRow>
            <EventUser event={event} />
            <EventText>
              sent an email{recipient ? ` to ${recipient}` : ''}
            </EventText>
          </EventRow>
        );
      }

      return (
        <div className="text-sm text-gray-700 mt-1 space-y-1">
          {payload.subject && (
            <div>
              <span className="font-semibold">Subject:</span> {payload.subject}
            </div>
          )}
          {recipient && (
            <div>
              <span className="font-semibold">To:</span> {recipient}
            </div>
          )}
          {payload.is_reply && (
            <div className="text-gray-500 text-xs">Reply to conversation</div>
          )}
        </div>
      );
    },
    description: (event: any) => {
      const { payload } = event;
      const recipient =
        payload.recipient_email || payload.recipient_name || 'client';
      return `sent email to ${recipient}`;
    },
  },

  client_communication_sms_sent: {
    icon: ChatBubbleLeftIcon,
    iconColor: 'text-green-500',
    priority: 'medium',
    render: (event: any, inline: boolean) => {
      const { payload } = event;
      const recipient = payload.recipient_phone || payload.recipient_name;

      if (inline) {
        return (
          <EventRow>
            <EventUser event={event} />
            <EventText>
              sent a text message{recipient ? ` to ${recipient}` : ''}
            </EventText>
          </EventRow>
        );
      }

      return (
        <div className="text-sm text-gray-700 mt-1 space-y-1">
          {recipient && (
            <div>
              <span className="font-semibold">To:</span> {recipient}
            </div>
          )}
          {payload.message_preview && (
            <div className="text-gray-600 text-xs italic line-clamp-2">
              &quot;{payload.message_preview}&quot;
            </div>
          )}
        </div>
      );
    },
    description: (event: any) => {
      const { payload } = event;
      const recipient =
        payload.recipient_phone || payload.recipient_name || 'client';
      return `sent text message to ${recipient}`;
    },
  },

  client_communication_phone_call_made: {
    icon: PhoneArrowUpRightIcon,
    iconColor: 'text-purple-500',
    priority: 'medium',
    render: (event: any, inline: boolean) => {
      const { payload } = event;
      const recipient = payload.recipient_phone || payload.recipient_name;

      if (inline) {
        return (
          <EventRow>
            <EventUser event={event} />
            <EventText>
              made a phone call{recipient ? ` to ${recipient}` : ''}
            </EventText>
          </EventRow>
        );
      }

      return (
        <div className="text-sm text-gray-700 mt-1 space-y-1">
          {recipient && (
            <div>
              <span className="font-semibold">To:</span> {recipient}
            </div>
          )}
          {payload.call_duration_seconds && (
            <div>
              <span className="font-semibold">Duration:</span>{' '}
              {Math.floor(payload.call_duration_seconds / 60)}m{' '}
              {payload.call_duration_seconds % 60}s
            </div>
          )}
          {payload.call_outcome && (
            <div>
              <span className="font-semibold">Outcome:</span>{' '}
              {payload.call_outcome}
            </div>
          )}
        </div>
      );
    },
    description: (event: any) => {
      const { payload } = event;
      const recipient =
        payload.recipient_phone || payload.recipient_name || 'client';
      return `called ${recipient}`;
    },
  },
};
/* eslint-enable @typescript-eslint/no-explicit-any */
